import "./style.css";
import layout from "./layout.html";
import chapters from "@data/chapters.json";

export default class Index {
  static selector = ".index";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
    this.photographerItemsNode = this.block.querySelector(
      ".index__content__photographers__items"
    );
  }

  setup = async () => {
    return new Promise(async (resolve) => {
      this.photographers.forEach((photographer) => {
        const span = document.createElement("span");
        span.textContent = photographer;

        this.photographerItemsNode.appendChild(span);
      });
      resolve();
    });
  };

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;

      this.photographers = Object.values(chapters)
        .map((chapter) => {
          const { cover, blocks } = chapter;

          const credits = [];

          if (cover?.credits?.author) {
            credits.push(cover.credits.author);
          }

          blocks.forEach((block) => {
            if (block?.attrs?.credits?.author) {
              credits.push(block.attrs.credits.author);
            }
            if (block?.attrs?.firstSection?.credits?.author) {
              credits.push(block.attrs.firstSection.credits.author);
            }
            if (block?.attrs?.secondSection?.credits?.author) {
              credits.push(block.attrs.secondSection.credits.author);
            }
            block?.attrs?.images?.forEach((image) => {
              if (image?.credits?.author) {
                credits.push(image.credits.author);
              }
            });
          });

          return credits;
        })
        .flat()
        .map((author) => author.split(" - "))
        .flat()
        .filter((author, index, self) => self.indexOf(author) === index)
        .sort((a, b) =>
          a.split(/[ ']+/).pop().localeCompare(b.split(/[ ']+/).pop())
        );

      await this.setup();

      resolve();
    });
  };
}
